import React from 'react';
import Layout from '../components/Layout/Layout';

// Import infrastructure images (using pre-team visit images as they match the screenshot)
import infra1 from '../images/preteamvisit1.jpg';
import infra2 from '../images/preteamvisit2.jpg';
import infra3 from '../images/preteamvisit3.jpg';
import infra4 from '../images/preteamvisit4.jpg';
import infra5 from '../images/preteamvisit5.jpg';
import infra6 from '../images/preteamvisit6.jpg';
import infra7 from '../images/preteamvisit7.jpg';

const InfrastructureGalleryPage = () => {
  const images = [infra1, infra2, infra3, infra4, infra5, infra6, infra7];

  return (
    <Layout>
      <div id="infrastructure-gallery" className="page-container" style={{ maxWidth: '1200px', margin: '40px auto', padding: '0 20px', minHeight: '500px' }}>
        
        <h2 style={{ color: '#004d99', paddingBottom: '20px', marginBottom: '30px', textAlign: 'center', fontSize: '2.8rem', fontWeight: 'bold' }}>
          Infrastructure Gallery
        </h2>

        <div style={{ 
          backgroundColor: '#333', 
          borderLeft: '6px solid #0056b3', 
          padding: '20px', 
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
        }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
            gap: '15px'
          }}>
            {images.map((img, index) => (
              <div key={index} style={{
                borderRadius: '4px',
                overflow: 'hidden',
                boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
                height: '250px'
              }}>
                <img 
                  src={img} 
                  alt={`Infrastructure ${index + 1}`} 
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                />
              </div>
            ))}
          </div>
        </div>

      </div>
    </Layout>
  );
};

export default InfrastructureGalleryPage;
